import React, { useEffect, useState } from 'react'
import moment from 'moment'

export const sortArray = (array) => {
    return array.sort((a, b) => {
        return a.id - b.id
    })
}

export const formatDate = (date: string, format?: string) => {
    const newDate = new Date(date)
    return moment(moment.utc(newDate).format()).format(
        format ? format : 'DD/MM/YYYY HH:mm'
    )
}

export const formatDateRequest = (date: string) => {
    const newDate = new Date(date)
    const formatDate = moment(moment.utc(newDate).format()).format('YYYY-MM-DD')
    return formatDate + 'T00:00:00.000Z'
}

export const findGetParameter = (parameterName) => {
    var result = null,
        tmp = []
    var items = location.search.substr(1).split('&')
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
    }
    return result
}

export const changeBreadcrumbs = (title?: string) => {
    let breadcrumbs = document.getElementsByClassName('wardrobe-breadcrumb')[0]
        .firstChild as HTMLElement
    let breadcrumbsLast = breadcrumbs.lastChild.firstChild
        .firstChild as HTMLElement
    breadcrumbsLast.innerText = title ? title : '-'
}

export const getQuery = (obj: any): string => {
    let haveAlreadyParams: boolean = false
    let query: string = ''
    if (obj) {
        query += '?'
        Object.keys(obj).map((key) => {
            const value: any = obj[key]
            if (
                value !== null &&
                value !== undefined &&
                value.toString().length > 0
            ) {
                if (haveAlreadyParams) {
                    query += '&'
                }
                query += key + '=' + JSON.stringify(value)
                haveAlreadyParams = true
            }
        })
        if (!haveAlreadyParams) {
            return ''
        }
    }
    return query
}

export const s2ab = (s: any) => {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
}

export const getDifferences = (array1: any[], array2: any[], field: string) => {
    return array1.filter((object1) => {
        return !array2.some((object2) => {
            return object1[field] === object2[field]
        })
    })
}

export const isMobileChecker = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return isMobile
}

export const getRemainingDays = (startDate: any, endDate: any): number => {
    let _diff = endDate.diff(startDate, 'days')
    return _diff < 0 ? _diff - 1 : _diff
}

// export const beforeUnloadCallback = (e) => {
//     e.preventDefault()
//     e.returnValue = ''
// }
